import { FETCH_SMART_ADDRESS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_SMART_ADDRESS:
      return { ...state, [action.id]: action.payload }
    default:
      return state
  }
}
